import { ISiteContent } from '../interfaces/i-site-content';

export const getSiteContentMarkup = (content: ISiteContent) => {
  const __html = content.content_en;
  return { __html };
};
